export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || "G-XXXXXXXXXX";

export function gtag(...args) {
    if (typeof window !== "undefined" && window.gtag) {
        window.gtag(...args);
    }
}

export function pageview(url) {
    gtag("config", GA_MEASUREMENT_ID, { page_path: url });
}
export function mapItem(product, { quantity = 1, index = 0, listName = "" } = {}) {
    const price =
        product.priceReduced && parseFloat(product.priceReduced) < parseFloat(product.price)
            ? parseFloat(product.priceReduced)
            : parseFloat(product.price || 0);

    return {
        item_id: String(product.id),
        item_name: product.name || "",
        item_category: product.category || product.categoryName || "",
        price: parseFloat(price.toFixed(2)),
        quantity,
        index,
        ...(listName ? { item_list_name: listName } : {}),
        ...(product.brand ? { item_brand: product.brand } : {}),
    };
}

export function viewItemList(products, listName = "Product List") {
    gtag("event", "view_item_list", {
        item_list_name: listName,
        items: products.map((p, i) => mapItem(p, { index: i, listName })),
    });
}

export function viewItem(product) {
    const item = mapItem(product);
    gtag("event", "view_item", {
        currency: "RON",
        value: item.price,
        items: [item],
    });
}

export function addToCart(product, quantity = 1) {
    const item = mapItem(product, { quantity });
    gtag("event", "add_to_cart", {
        currency: "RON",
        value: parseFloat((item.price * quantity).toFixed(2)),
        items: [item],
    });
}

export function removeFromCart(product, quantity = 1) {
    const item = mapItem(product, { quantity });
    gtag("event", "remove_from_cart", {
        currency: "RON",
        value: parseFloat((item.price * quantity).toFixed(2)),
        items: [item],
    });
}

export function viewCart(cartItems, cartProducts) {
    const items = cartItems
        .map((p) => {
            const cartEntry = cartProducts.find((c) => c.id == p.id);
            return mapItem(p, { quantity: cartEntry?.quantity || 1 });
        });

    const value = items.reduce((s, i) => s + i.price * i.quantity, 0);

    gtag("event", "view_cart", {
        currency: "RON",
        value: parseFloat(value.toFixed(2)),
        items,
    });
}

export function beginCheckout(cartItems, cartProducts, coupon = "") {
    const items = cartItems.map((p) => {
        const entry = cartProducts.find((c) => c.id == p.id);
        return mapItem(p, { quantity: entry?.quantity || 1 });
    });
    const value = items.reduce((s, i) => s + i.price * i.quantity, 0);

    gtag("event", "begin_checkout", {
        currency: "RON",
        value: parseFloat(value.toFixed(2)),
        items,
        ...(coupon ? { coupon } : {}),
    });
}

export function addShippingInfo(cartItems, cartProducts, shippingMethod = "Standard") {
    const items = cartItems.map((p) => {
        const entry = cartProducts.find((c) => c.id == p.id);
        return mapItem(p, { quantity: entry?.quantity || 1 });
    });
    const value = items.reduce((s, i) => s + i.price * i.quantity, 0);

    gtag("event", "add_shipping_info", {
        currency: "RON",
        value: parseFloat(value.toFixed(2)),
        shipping_tier: shippingMethod,
        items,
    });
}

export function addPaymentInfo(cartItems, cartProducts, paymentMethod = "") {
    const items = cartItems.map((p) => {
        const entry = cartProducts.find((c) => c.id == p.id);
        return mapItem(p, { quantity: entry?.quantity || 1 });
    });
    const value = items.reduce((s, i) => s + i.price * i.quantity, 0);

    gtag("event", "add_payment_info", {
        currency: "RON",
        value: parseFloat(value.toFixed(2)),
        payment_type: paymentMethod,
        items,
    });
}

export function purchase({ transactionId, items, value, shipping = 22, coupon = "" }) {
    gtag("event", "purchase", {
        transaction_id: String(transactionId),
        currency: "RON",
        value: parseFloat(value.toFixed(2)),
        shipping,
        tax: parseFloat((value * 0.21 / 1.21).toFixed(2)),
        items,
        ...(coupon ? { coupon } : {}),
    });
}

/**
 * Trimite evenimentul de purchase in formatul GTM (dataLayer.push cu ecommerce.*),
 * cerut de echipa de marketing pentru trigger-ul de conversie din GTM.
 * Separat de purchase() de mai sus, care merge direct prin gtag() (tag GA4 direct, nu GTM).
 */
export function pushPurchaseToDataLayer({ transactionId, value, shipping = 0, tax = 0, items = [] }) {
    if (typeof window === "undefined") return;

    window.dataLayer = window.dataLayer || [];
    // Golim obiectul ecommerce anterior inainte de un nou push (recomandarea Google
    // pentru dataLayer, ca sa nu se amestece campurile intre evenimente succesive).
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: "purchase",
        ecommerce: {
            transaction_id: String(transactionId),
            value: Number(value),
            currency: "RON",
            shipping: Number(shipping || 0),
            tax: Number(tax || 0),
            items: items.map((item) => ({
                item_id: String(item.item_id ?? item.id),
                item_name: item.item_name ?? item.name,
                price: Number(item.price),
                quantity: Number(item.quantity),
            })),
        },
    });
}

export function addToWishlist(product) {
    const item = mapItem(product);
    gtag("event", "add_to_wishlist", {
        currency: "RON",
        value: item.price,
        items: [item],
    });
}

export function search(term) {
    gtag("event", "search", { search_term: term });
}
